export default __webpack_public_path__ + "static/media/airport-security.298ec803.jpg";